import { deepOrange, green, grey } from '@mui/material/colors';
import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para situações de voto.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const SITUACAO_VOTO = {
    SEM_VOTO:                  { id: 'SEM_VOTO',                  descricao: 'Não registrado',                                   codigo: 1, cor: grey[600]       },
    PRE_VOTADO:                { id: 'PRE_VOTADO',                descricao: 'Pré-votado (Não confirmado)',                      codigo: 2, cor: grey[600]       },
    CONFIRMADO:                { id: 'CONFIRMADO',                descricao: 'Confirmado',                                       codigo: 3, cor: green[800]      },
    REVOGADO:                  { id: 'REVOGADO',                  descricao: 'Revogado',                                         codigo: 4, cor: deepOrange[700] },
    CONFIRMADO_TACITAMENTE:    { id: 'CONFIRMADO_TACITAMENTE',    descricao: 'Confirmado tacitamente',                           codigo: 5, cor: green[800]      },
    NAO_CONFIRMADO_PRESENCIAL: { id: 'NAO_CONFIRMADO_PRESENCIAL', descricao: 'Sem registro de confirmação em sessão presencial', codigo: 6, cor: grey[900]       },
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de situações de voto.
 * @readonly
 */
class SituacaoVoto {
    static situacaoBase = new SituacaoIdDescricaoBase(SITUACAO_VOTO);
    static MSG_ERRO_IDENTIFICACAO_SITUACAO_VOTO = 'Não foi possível identificar a situação do voto.';

    static getDescricao(id) {
        return SituacaoVoto.situacaoBase.getDescricao(id);
    }

    static getCodigo(id) {
        return SituacaoVoto.situacaoBase.getValorPropriedade(id, 'codigo');
    }

    static getCor(id) {
        return SituacaoVoto.situacaoBase.getValorPropriedade(id, 'cor');
    }

    static getCorByCodigo(codigo) {
        const obj = SituacaoVoto.situacaoBase.getObjectByProperty('codigo', codigo);
        return obj ? SituacaoVoto.getCor(obj.id) : 'black';
    }
}

export default SituacaoVoto;
